import {
  BETWEEN,
  CONTAIN,
  END_WITH,
  EQUAL,
  GREATER_THAN,
  GREATER_THAN_OR_EQUAL,
  IGNORE_CASE_EQUAL,
  IGNORE_CASE_LIKE,
  IGNORE_CASE_NOT_LIKE,
  IN,
  IS_NOT_NULL,
  IS_NULL,
  LESS_THAN,
  LESS_THAN_OR_EQUAL,
  LIKE,
  NOT_BETWEEN,
  NOT_CONTAIN,
  NOT_EQUAL,
  NOT_IN,
  NOT_LIKE,
  START_WITH,
  JSON_EXTRACT_EQUAL,
  JSON_EXTRACT_LIKE,
} from 'shared/constants/QueryModes';

export const buildQuery = (params) => {
  let query = params?.pagination
    ? `?page=${params.pagination.current - 1}&size=${
        params.pagination.pageSize
      }`
    : '';

  if (params?.sorters?.length > 0) {
    let sortString = '';
    for (let index in params.sorters) {
      if (params.sorters[index].field) {
        sortString += `sort=${params.sorters[index].field}:${
          params.sorters[index].order === 'ascend' ? 'asc' : 'desc'
        }&`;
      }
    }

    if (sortString.charAt(sortString.length - 1) === '&') {
      sortString = sortString.substring(0, sortString.length - 1);
    }

    query += query.length > 0 ? `&${sortString}` : `?${sortString}`;
  }

  if (params?.filters?.length > 0) {
    let filterString = '';
    for (let index in params.filters) {
      let fields = params.filters[index]['fields'];
      let value = params.filters[index]['value'];
      let mode = params.filters[index]['mode'] || EQUAL;

      if (value || typeof value === 'boolean') {
        if (Array.isArray(value)) {
          let _value = '(';
          value.forEach((v) => {
            _value += v + ',';
          });

          _value = _value.slice(0, -1) + `)`;
          value = _value;
        } else {
          value = "'" + value + "'";
        }

        if (Array.isArray(fields)) {
          filterString += `(`;
          fields.forEach((field) => {
            filterString += `${buildFilterString(field, mode, value)},`;
          });
          filterString = filterString.slice(0, -1) + `);`;
        } else if (fields) {
          filterString += `${buildFilterString(fields, mode, value)};`;
        }
      }
    }

    if (
      filterString.charAt(filterString.length - 1) === ';' ||
      filterString.charAt(filterString.length - 1) === ','
    ) {
      filterString = filterString.substring(0, filterString.length - 1);
    }

    filterString = encodeURIComponent(filterString)
      .replace(/-/g, '%2D')
      .replace(/_/g, '%5F')
      .replace(/\./g, '%2E')
      .replace(/!/g, '%21')
      .replace(/~/g, '%7E')
      .replace(/\*/g, '%2A')
      .replace(/'/g, '%27')
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29');

    query +=
      query.length > 0 ? '&query=' + filterString : '?query=' + filterString;
  }

  return query;
};

const buildFilterString = (field, mode, value) => {
  let filterString = '';

  if (mode === BETWEEN) {
    filterString += `${field}=bt=${value}`;
  } else if (mode === NOT_BETWEEN) {
    filterString += `${field}=nb=${value}`;
  } else if (mode === CONTAIN) {
    filterString += `${field}=ke=${value}`;
  } else if (mode === NOT_CONTAIN) {
    filterString += `${field}=nk=${value}`;
  } else if (mode === LIKE) {
    filterString += `${field}=ke=${value}`;
  } else if (mode === NOT_LIKE) {
    filterString += `${field}=nk=${value}`;
  } else if (mode === IGNORE_CASE_LIKE) {
    filterString += `${field}=ik=${value}`;
  } else if (mode === IGNORE_CASE_EQUAL) {
    filterString += `${field}=ic=${value}`;
  } else if (mode === IGNORE_CASE_NOT_LIKE) {
    filterString += `${field}=ni=${value}`;
  } else if (mode === START_WITH) {
    filterString += `${field}==${value}*`;
  } else if (mode === END_WITH) {
    filterString += `${field}==*${value}`;
  } else if (mode === EQUAL) {
    filterString += `${field}==${value}`;
  } else if (mode === NOT_EQUAL) {
    filterString += `${field}!=${value}`;
  } else if (mode === IN) {
    filterString += `${field}=in=${value}`;
  } else if (mode === NOT_IN) {
    filterString += `${field}=out=${value}`;
  } else if (mode === LESS_THAN) {
    filterString += `${field}=lt=${value}`;
  } else if (mode === LESS_THAN_OR_EQUAL) {
    filterString += `${field}=le=${value}`;
  } else if (mode === GREATER_THAN) {
    filterString += `${field}=gt=${value}`;
  } else if (mode === GREATER_THAN_OR_EQUAL) {
    filterString += `${field}=ge=${value}`;
  } else if (mode === IS_NULL) {
    filterString += `${field}=na=${value}`;
  } else if (mode === IS_NOT_NULL) {
    filterString += `${field}=nn=${value}`;
  } else if (mode === JSON_EXTRACT_EQUAL) {
    filterString += `${field}=je=${value}`;
  } else if (mode === JSON_EXTRACT_LIKE) {
    filterString += `${field}=jl=${value}`;
  }

  return filterString;
};
